import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { AuthProvider } from './core';
import { loadConfig } from "./config";

async function bootstrap() {
  try {
    await loadConfig();
    const { default: App } = await import("./App");
    ReactDOM.render(
      <React.StrictMode>
        <AuthProvider>
          <App />
        </AuthProvider>
      </React.StrictMode>,
      document.getElementById('root')
    );
  } catch (err) {
    document.getElementById("root").innerHTML = `
      <div style="padding:2rem;color:red">
        <b>Failed to start:</b> ${err.message}
      </div>`;
  }
}

bootstrap();